<template>
  <!-- <button
      v-if="!authUser"
      @click="$router.push({ name: 'Login' })"
      :style="{ background: getPrimaryFallbackColor() }"
      class="dovemed-button font-white btn-center px-3 px-md-0"
    >
      LOGIN
    </button> -->
  <div class="dovemed-wrapper-lg">
    <div class="row col-md-12 m-0 wrap">
      <div class="col-sm-12 col-md-4" v-for="(circle, index) in myCircles" :key="index + circle.post_count + circle.comment_count + circle.user_count">
        <div class="circle-card mb-5 mb-md-0">
          <div class="circle-card-content">
            <div class="img" :style="`background-color:${circle.color_code}`"></div>
            <div class="head">
              <p class="head-1">{{ circle.condition_type }}</p>
              <P :class="circle.description ? 'head2' : 'head2 invisible'">{{ circle.description || "." }}</P>
            </div>
            <table class="circle-table">
              <tbody>
                <tr class="w-100 d-flex">
                  <td class="text-center" style="flex: 1">
                    {{ circle.post_count }}
                  </td>
                  <td class="text-center" style="flex: 1">
                    {{ circle.comment_count }}
                  </td>
                  <td class="text-center" style="flex: 1">
                    {{ circle.user_count }}
                  </td>
                </tr>
                <tr class="w-100 d-flex">
                  <td class="text-center" style="flex: 1">POSTS</td>
                  <td class="text-center" style="flex: 1">REPLIES</td>
                  <td class="text-center" style="flex: 1">MEMBERS</td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <div class="circle-card-footer">
            <!-- <a id="enter" @click="goToCircle(circle, $event, true)" class="circle-resource-link">VIEW RESOURCES</a> -->
            <button @click="goToCircle(circle, $event)" id="enter" class="dovemed-button enter-button m-auto">ENTER</button>

            <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <!-- <button
              @click="goToCircle(circle, $event)"
              id="enter"
              class="dovemed-button enter-button m-auto"
            >
              ENTER
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="more-coming-card" v-if="authUser">
        <p class="card">More conditions coming soon</p>
      </div>

      <div class="cant-find-condition shadow-card mt-5">
        <p class="mb-0 title">Can’t find your condition?</p>
        <p class="mb-0 sub-text">Send us a message if you want to see MyCircles work on your chronic condition.</p>
        <button @click="$router.push({ name: 'ContactUs' })" id="enter" class="dovemed-button primary-dark-background font-white mt-5 bold-text">CONTACT US</button>
      </div>
    </div>
    <EmailVerifyModal ref="emailVerifyModal" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import EmailVerifyModal from "../../Modals/EmailVerification"

const CircleRepository = RepositoryFactory.get("circle")
const UserRepository = RepositoryFactory.get("user")

/**
 * Circle Management
 * @displayName Circles
 */
export default {
  name: "MyCircles",

  data() {
    return {
      allCircles: null,
      myCircles: null,
      registeredCircle: null,
    }
  },

  created() {
    console.warn("MyCircles.vue is created")
  },

  mounted() {
    this.init()
  },
  components: {
    EmailVerifyModal,
  },

  methods: {
    /**
     * Initialization
     */
    async init() {
      await CircleRepository.all("", "")
        .then(async res => {
          this.registeredCircle = this.authUser ? res.data.data.my_circles : []
          this.authUser ? (this.allCircles = await this.circleDiff(res.data.data.all_circles)) : (this.allCircles = await res.data.data.all_circles)
        })
        .catch(err => {})
    },

    /**
     * Filter circles based on the condition that it's present in mycicles or not
     *
     * @param {Array} allCircles
     */
    circleDiff(allCircles) {
      if (this.authUser) {
        const userCircles = this.registeredCircle.map(c => c.id)
        const dataDiff = allCircles.filter(cir => {
          return userCircles.includes(cir.id)
        })
        this.myCircles = dataDiff

        return dataDiff
      }
    },

    /**
     * Go to diffent circle page based on user selection
     *
     * @param {Object} circle
     * @param {Object} event
     */
    goToCircle(circleInfo, event, bool) {
      this.setAppLoaderStatus(true)
      CircleRepository.all("", circleInfo.id)
        .then(res => {
          let circle = res.data.data.all_circles[0]
          //write this login in header my profile before routing
          UserRepository.getSelfProfile(this.authUser.user, circle.id)
            .then(res => {
              const data = {
                ...res.data.data.user_info,
                no_of_members: res.data.data.no_of_members,
              }
              // console.log(data, "dadata ad");
              this.$store.commit("User/setAuthUserDisplayName", { data: res.data.data.user_info.display_name || "D" })
              // this.$store.commit("User/setAuthUserDisplayName", { data: res.data.data.user_info.display_name ? res.data.data.user_info.display_name.toLowerCase() : "D" })
              this.$store.commit("User/setCircleProfile", { data: data })
              const target = event.target.id
              this.$store.commit("Circle/setCurrentCircle", { data: circle })
              this.setAppLoaderStatus(false)
              target === "enter" ? this.checkAndRoute(circle, bool) : this.$router.push(`/${circle.key_name}/signup`)
              this.setAppLoaderStatus(false)
            })
            .catch(err => {
              this.setAppLoaderStatus(false)
            })
        })
        .catch(err => {
          console.log(err)
        })
    },

    checkAndRoute(circle, bool) {
      UserRepository.isActive({ email: this.authUser.user.email })
        .then(res => {
          if (bool) {
            this.$router.push(`/${circle.key_name}/home/resources`)
          } else {
            this.$router.push(`/${circle.key_name}/home/activity`)
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error",
            description: "Email not verified",
          })
          this.$refs.emailVerifyModal.show()
        })
    },

    // setCircleProfile (circle) {
    // }
  },
}
</script>

<style>
.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}
.btn-center {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
.enter-button {
  /* border: 1px solid #1674bf !important; */
  background: #fff;
  color: #1674bf !important;
}
</style>



// WEBPACK FOOTER //
// src/components/App/circle/MyCircles.vue